import StaffPanel from '@screens/staff/panel'

export default function StaffPanelPage() {
  return <StaffPanel />
}
